/**
 * Component: Header navigation
 *
 * Dependencies:
 * - OwlCarousel 2.x.x
 */

var prongHorn = prongHorn || {};

prongHorn.navigation = prongHorn.navigation || function() {

    this.collapseMenu = function(selector) {
        var $header = $(selector);

        // If the header is loaded
        if ($header.length > 0) {

            // Hide Header on on scroll down
            var didScroll;
            var lastScrollTop = 0;
            var delta = 5;
            var navbarHeight = $header.outerHeight();

            $(window).scroll(function(event){
                didScroll = true;
            });

            setInterval(function() {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 250);

            function hasScrolled() {
                var st = $(this).scrollTop();
                var dropdownIsActive = $('body').hasClass('site__dropdown-active') ? true : false;
                
                // Make sure they scroll more than delta
                if(Math.abs(lastScrollTop - st) <= delta)
                    return;
                
                // If they scrolled down and are past the navbar, add class .nav-up.
                // This is necessary so you never see what is "behind" the navbar.
                if (st > lastScrollTop && st > navbarHeight && !dropdownIsActive){
                    // Scroll Down
                    $header.addClass('header--collapsed');


                } else {
                    // Scroll Up
                    if(st + $(window).height() < $(document).height()) {
                        $header.removeClass('header--collapsed');
                    }
                }
                
                lastScrollTop = st;
            }

        }
    };

    this.offCanvasMenu = function(trigger, selector, url) {
        var $trigger = $(trigger),
            $triggerOverlay = $('#offcanvas-overlay'),
            $body = $('body'),
            $selector = $(selector);


        if ($selector.length > 0) {

            var menuIsLoaded = false;
            var menuOpen = false;


            $body.on('click', trigger, function(event) {
                event.preventDefault();

                toggleMenu();
                prongHorn.offcanvas.init();

            });

            $triggerOverlay.click(function(event) {
                event.preventDefault();
                toggleMenu();
            })

            function toggleMenu() {

                if(!menuOpen) {
                    $body.addClass('site__offcanvas-active');
                    menuOpen = true;
                } else {
                    $body.removeClass('site__offcanvas-active');
                    menuOpen = false;
                }

            }

        }

    };

    this.showSearch = function() {
        var $trigger = $('.js-search-trigger'),
            $searchContainer = $('.search');


        if ($searchContainer.length > 0) {

            var searchOpen = false;

            $trigger.click(function(event) {
                event.preventDefault();
                toggleSearch();
            })

            function toggleSearch() {

                if(!searchOpen) {
                    $searchContainer.addClass('search--active');
                    searchOpen = true;
                } else {
                    $searchContainer.removeClass('search--active');
                    searchOpen = false;
                }

            }

        }
    }

    // Public functions
    return {
        collapseMenu: collapseMenu,
        offCanvasMenu: offCanvasMenu,
        showSearch: showSearch
    };

}();